module.exports = __webpack_public_path__ + "img/5.eef3fec7.jpg";